<div tabindex="0" class="me-payment-coupon-card" *ngIf="data">
    <div class="me-payment-coupon-card__header">
        {{packageData.title}}
    </div>
    <div class="me-payment-coupon-card__description">
        <div class="me-payment-coupon-card__description__name">
            {{packageData.priceText}}
        </div>
        <div class="me-payment-coupon-card__description__price">
            <div>
                {{amountDisplay}}
            </div>
            <div class="me-payment-coupon-card__description__price__tax">
                <span class="me-payment-coupon-card__description__price__tax__header">
                    {{'Tax rate' | translate}} {{taxPercent}}%
                </span>
                <span class="me-payment-coupon-card__description__price__tax__description">
                    {{taxAmountDisplay}}
                </span>
            </div>
            <div class="me-payment-coupon-card__description__price__tax">
                <span class="me-payment-coupon-card__description__price__tax__header">
                    {{'Net price' | translate}}
                </span>
                <span class="me-payment-coupon-card__description__price__tax__description">
                    {{amountWithoutTaxDisplay}}
                </span>
            </div>
        </div>
    </div>
    <div class="me-payment-coupon-card__code" *ngIf="!discountPercent">
        <span tabindex="0" class="me-payment-coupon-card__code__header" (click)="addCoupon = !addCoupon" (keydown.enter)="addCoupon = !addCoupon">
            <ng-container *ngIf="!addCoupon">
                <i class="fal fa-plus"></i>{{data.add}}
            </ng-container>
            <ng-container *ngIf="addCoupon">
                <i class="fal fa-minus"></i>{{data.remove}}
            </ng-container>
        </span>
        <div *ngIf="addCoupon">
            <form [formGroup]="form">
                <div class="row">
                    <div class="col-xs-12 mt-1">
                        <div class="me-form-input-group">
                            <div class="me-form-input" [class.error]="!(form.controls.code.valid
                            || (form.controls.code.pristine && !submitted))">
                                <label class="me-form-input__label">{{data.label}}</label>
                                <input title="{{'Please fill out this field.' | translate}}" maxlength="6" placeholder="{{data.placeholder}}" formControlName="code" class="me-form-input__input" />
                            </div>
                            <small [hidden]="form.controls.code.valid
                            || (form.controls.code.pristine && !submitted)"
                            class="me-form-input__error">
                                {{ 'This field is required.' | translate }}
                            </small>
                        </div>
                    </div>
                    <div class="col-xs-12 mt-1">
                        <button class="btn btn--secondary w-100" (click)="submit(form.value, form.valid)">
                            {{data.apply}}
                        </button>
                    </div>
                </div>
            </form>
            <div class="col-xs-12 mt-1 errorMessage" *ngIf="errorMessage">
               {{errorMessage}}
            </div>
        </div>
    </div>
    <div class="me-payment-coupon-card__discount" *ngIf="discountPercent">
        <div class="me-payment-coupon-card__discount__row">
            <div class="me-payment-coupon-card__discount__row__description">
                <span>{{'Save' | translate}}</span>
                <span>{{discountPercent}}%</span>
            </div>
            <div>
                - {{discountPriceDisplay}}
            </div>
        </div>
        <div class="me-payment-coupon-card__discount__divider"></div>
        <div class="me-payment-coupon-card__discount__row">
            <div class="me-payment-coupon-card__discount__row__description">
                <span>{{'New price' | translate}}</span>
            </div>
            <div>
               {{newPriceDisplay}}
            </div>
        </div>
    </div>
    <div class="me-payment-coupon-card__info">
        {{data.info}}
    </div>
</div>